export default __webpack_public_path__ + "static/media/logoson.32e74435.png";